/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsCheckoutHeadData } from './mands-checkout-head.data';
import { IMandsCheckoutHeadProps } from './mands-checkout-head.props.autogenerated';

/**
 *
 * MandsCheckoutHead component
 * @extends {React.PureComponent<IMandsCheckoutHeadProps<IMandsCheckoutHeadData>>}
 */
export default class MandsCheckoutHead extends React.PureComponent<IMandsCheckoutHeadProps<IMandsCheckoutHeadData>> {
    public render(): JSX.Element {
        const {
            config: { homeLink, padLockImage, mandsLogoImage }
        } = this.props;

        return (
            <div className='checkout-header'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-4 checkout-header-left'>{padLockImage && <img src={padLockImage.src} alt='lock' />}</div>
                        <div className='col-md-4 checkout-header-center'>
                            {homeLink && (
                                <a href={homeLink.linkUrl.destinationUrl}>
                                    {mandsLogoImage && (
                                        <img src={mandsLogoImage.src} className='checkout-logo' alt='Mark and spencer Uniform' />
                                    )}
                                </a>
                            )}
                        </div>
                        <div className='col-md-4 checkout-header-right'>
                            <span className='checkout-header-payment' />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
